import { StablesOperationPage } from "./StablesOperationPage";

export const StablesVender = () => (
  <StablesOperationPage
    operation="sell"
    title="Vender stablecoins"
    subTitle="Converta USDC ou USDT em reais. Acompanhe suas vendas no histórico abaixo."
    historyType="sales"
    historyTitle="Histórico de vendas"
  />
);
